import { render, staticRenderFns } from "./TestTaskServerTable.vue?vue&type=template&id=86ac8fd4"
import script from "./TestTaskServerTable.vue?vue&type=script&lang=js"
export * from "./TestTaskServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports